export default "__VITE_ASSET__392a74cb__"